import { get, post, put } from '@/utils/xhr'
import { PasskeyService } from './passkey'

class Wallet {
  GetAll = () => get('/wallet')
  Create = async ({ encryptionKey, address }: { encryptionKey: string; address: string }) => {
    return post('/wallet', { encryptionKey, address })
  }
  Passphrase = async () => {
    const { asseResp } = await PasskeyService.AuthOptions()
    return post(`/wallet/passphrase`, {
      payload: asseResp,
    })
  }
  SetupRecovery = async (walletIds: string[]) => {
    const { asseResp } = await PasskeyService.AuthOptions()
    return post(`/recovery/init-recovery`, {
      payload: asseResp,
      wallets: walletIds,
    })
  }
  SendServerSecret = async (payload: any) => {
    return post(`/recovery/save-server-secret`, payload)
  }
  GetServerSecret = async (hash: string) => {
    return post(`/recovery/get-server-secret`, { hash })
  }
  GetWalletInfo = (walletId: string) => get(`/wallet/${walletId}`)
  UpdateWallet = (walletId: string, payload: any) => put(`/wallet/${walletId}`, payload)
  markBackupAsDone = (type: string, email?: string) =>
    post(`/wallet/mark-as-backedup`, {
      type,
      email,
    })

  claimGift = () => post('/wallet/claim-gift')
}
export const WalletService = new Wallet()
